// ---------------------------------------------------------------------------
// LoadingSpinner — Shared full-page or inline loading indicator.
// ---------------------------------------------------------------------------

import { Spinner } from '@fluentui/react-components';

import type { LoadingSpinnerProps } from './LoadingSpinner.interface';

export function LoadingSpinner({ label = 'Loading...' }: LoadingSpinnerProps) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        minHeight: '200px',
      }}
    >
      <Spinner size="large" label={label} />
    </div>
  );
}
